//import { isAnyOf } from '@reduxjs/toolkit'
import { createAppSlice } from '../../app/createAppSlice'
//import { startAppListening } from '../../app/listenerMiddleware'

const initialState = {
    userId: "",
    name: "",
    userPublicDetail: null,
    userPrivateDetail: null,
    status: "idle",
    websiteView: (typeof window === "undefined" || window.innerWidth > 768 || !("ontouchstart" in window || navigator.maxTouchPoints > 0)) ? "desktop" : "mobile", //smallScreen = window.matchMedia("(max-width: 768px)").matches;
    connectionId: null
}

const currentUserSlice = createAppSlice({
    name: "currentUser",
    initialState,
    reducers: create => ({
        userLoggedIn: create.reducer((state, action) => {
            state.userId = action.payload.userId
            state.name = action.payload.name
            state.userPublicDetail = action.payload.userPublicDetail
            state.userPrivateDetail = action.payload.userPrivateDetail
            state.status = "succeeded"
        }),
        userLoggedOut: create.reducer((state) => {
            state.userId = "1"
            state.name = "Anonymous"
            state.userPublicDetail = null
            state.userPrivateDetail = null
            state.status = "notLoggedIn"
        }),
        changeWebsiteView: create.reducer((state, action) => {
            state.websiteView = action.payload
        }),
        changeSseConnectionId: create.reducer((state, action) => {
            state.connectionId = action.payload
        }),
        numberUnreadNotificationsChanged: create.reducer((state, action) => {
            state.userPrivateDetail.numberunreadnotifications = action.payload
        }),
        numberUnClearedNotificationsChanged: create.reducer((state, action) => {
            state.userPrivateDetail.numberunclearednotifications = action.payload
        }),
        m11useChanged: create.reducer((state, action) => {
            state.userPrivateDetail.m11use = action.payload
        })
    }),
    selectors: {
        selectCurrentUserStatus: currentUser => currentUser.status,
        selectCurrentUserError: currentUser => currentUser.error,
        selectCurrentUserId: currentUser => currentUser.userId,
        selectCurrentUserName: currentUser => currentUser.name,
        selectCurrentUserAdmin: currentUser => currentUser.userPrivateDetail?.admin,
        selectCurrentUserApiToken: currentUser => currentUser.userPrivateDetail?.apiToken,
        selectCurrentUserIdToken: currentUser => currentUser.userPrivateDetail?.idToken,
        selectCurrentUserNotificationEmail: currentUser => currentUser.userPrivateDetail?.notificationemail,
        selectCurrentUserFavoriteFois: currentUser => currentUser.userPrivateDetail?.favoritefois,
        selectCurrentUserNotificationFois: currentUser => currentUser.userPrivateDetail?.notificationfois,
        selectCurrentUserNumberUnreadNotifications: currentUser => currentUser.userPrivateDetail?.numberunreadnotifications,
        selectCurrentUserNumberUnclearedNotifications: currentUser => currentUser.userPrivateDetail?.numberunclearednotifications,
        selectCurrentUserAdditionalEmail: currentUser => currentUser.userPrivateDetail?.additionalemail,
        selectCurrentUserShortBio: currentUser => currentUser.userPublicDetail?.shortbio,
        selectCurrentUserAffiliations: currentUser => currentUser.userPublicDetail?.affiliations,
        selectCurrentUserM11Use: currentUser => currentUser.userPrivateDetail?.m11use,
        selectCurrentUserTermsOfUseAccepted: currentUser => currentUser.userPrivateDetail?.termsofuseaccept,
        selectCurrentUserDataPersonalAgreementAccepted: currentUser => currentUser.userPrivateDetail?.datapersonalagreementaccept,
        selectDisplayTheTermsOfAgreement: currentUser => currentUser.userPrivateDetail?.displaythetermsofagreement,
        selectWebsiteView: currentUser => currentUser.websiteView,
        selectSseConnectionId: currentUser => currentUser.connectionId
    },
})

export const { userLoggedIn, userLoggedOut, changeWebsiteView, changeSseConnectionId, numberUnreadNotificationsChanged,
    numberUnClearedNotificationsChanged, m11useChanged
} = currentUserSlice.actions

export const { selectCurrentUserStatus, selectCurrentUserError,
    selectCurrentUserId, selectCurrentUserName, selectCurrentUserAdmin,
    selectCurrentUserIdToken, selectCurrentUserApiToken, selectCurrentUserNotificationEmail,
    selectCurrentUserFavoriteFois, selectCurrentUserNotificationFois,
    selectCurrentUserNumberUnreadNotifications, selectCurrentUserNumberUnclearedNotifications,
    selectCurrentUserAdditionalEmail, selectCurrentUserShortBio, selectCurrentUserAffiliations,
    selectCurrentUserM11Use,
    selectCurrentUserTermsOfUseAccepted, selectCurrentUserDataPersonalAgreementAccepted,
    selectDisplayTheTermsOfAgreement, selectWebsiteView, selectSseConnectionId
} = currentUserSlice.selectors
/*
export const addCurrentUserListeners = () => {

    startAppListening({
        matcher: isAnyOf(userLoggedIn, userLoggedOut),
        effect: async (action, listenerApi) => {
            //console.log("currentUser listener was triggered") //Commented out because it was flooding the console
            try {
                const userId = selectCurrentUserId(listenerApi.getState());
                if (userId) {
                    console.log(userId)
                    let user = firebase.auth().currentUser;
                    console.log(user)
                    //await user.getIdToken(true).then(async (storedIdToken) => { idToken = storedIdToken });

                } else {
                    //console.log("This should be triggered by userLoggedOut")  //Commented out because it was flooding the console

                }

            } catch (err) {
                console.log("FAILURE of userLoggedIn/Out: ", err)
            }
        }
    })
}
*/
export default currentUserSlice